export default __webpack_public_path__ + "static/media/lxk-symbol-2x.d1d84bf8.svg";